import { db } from '../firebase'
import { collection, doc, getDocs, query, where } from "firebase/firestore";


const companyServiceRef = collection(db, "ServiceCompany");
const userCollectionRef = collection(db, "User");


export const getCompanyServices = async (company) => {
    const q = await query(companyServiceRef, where("company", "==", await company));
    const data = (await getDocs(q)).docs.map((doc) => ({ ...doc.data(), id: doc.id }));


    return data;
}


export const getCompanyUsers = async (company) => {
    const q = await query(userCollectionRef, where("company", "==", company));
    const data = (await getDocs(q)).docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    return data;
}
